var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isArchived)?_c('SubmitButtonMagenta',{directives:[{name:"allowed",rawName:"v-allowed.editor",modifiers:{"editor":true}}],attrs:{"spinner-color":"#fff","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.archiveTemplate}},[_vm._v("\n  Archivar\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }